import { ButtonProps, ButtonVariants, Button as ShadcnButton } from 'src/core/components/shadcn/button'

export type { ButtonVariants }
export type Props = ButtonProps

const Button = (props: Props) => {
	const { ref, children, ...rest } = props

	return (
		<ShadcnButton {...rest} ref={ref}>
			{children}
		</ShadcnButton>
	)
}

export default Button
